/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-google-maps/node_modules/lodash/_freeGlobal.js
// module id = 652
// module chunks = 92